import {
    TOTAL_LIST_WIDTH,
    headerCellStyle,
    COL_WIDTHS,
} from "./helpers";

export function TaskListHeader({ headerHeight }) {
  return (
    <div
      style={{
        display: "flex",
        height: headerHeight,
        alignItems: "stretch",
        borderBottom: "2px solid #D1D5DB",
        borderTop: "1px solid #E5E7EB",
        borderLeft: "1px solid #E5E7EB",
        background: "#F9FAFB",
        width: TOTAL_LIST_WIDTH,
        position: "sticky",
        top: 0,
        zIndex: 20,
      }}
    >
      <div style={headerCellStyle(COL_WIDTHS.item, { alignItems: "flex-start", paddingLeft: 12 })}>
        ITEM
      </div>
      <div style={headerCellStyle(COL_WIDTHS.horasPrev)}>
        <span style={{ fontSize: 10, color: "#6B7280" }}>HORAS</span>
        <span>prev</span>
      </div>
      <div style={headerCellStyle(COL_WIDTHS.horasReal)}>
        <span style={{ fontSize: 10, color: "#6B7280", opacity: 0 }}>⏱</span>
        <span style={{ color: "#F59E0B" }}>real</span>
      </div>
      <div style={headerCellStyle(COL_WIDTHS.cnsum)}>
        <span style={{ fontSize: 10, color: "#6B7280" }}>CNSUM</span>
        <span>real/prev %</span>
      </div>
      <div style={headerCellStyle(COL_WIDTHS.progresso)}>
        % concluído
      </div>
    </div>
  );
}